// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---------- base ---------- */
:root {
  --accent: #27e8ff;
  --accent-dim: rgba(39, 232, 255, 0.35);
  --warn: #ffb347;
  --danger: #ff3b30;
  --panel: rgba(6, 14, 22, 0.72);
  --text: #d7f4ff;
  --font: 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;
}

* { margin: 0; padding: 0; box-sizing: border-box; }

html, body { width: 100%; height: 100%; overflow: hidden; background: #000; }

#app { position: fixed; inset: 0; }

#game-canvas { position: absolute; inset: 0; width: 100%; height: 100%; display: block; }

#ui-root {
  position: absolute; inset: 0;
  font-family: var(--font);
  color: var(--text);
  pointer-events: none;
  user-select: none;
}

/* ---------- shared bits ---------- */
.ns-btn {
  pointer-events: auto;
  display: block;
  min-width: 260px;
  margin: 10px auto;
  padding: 13px 34px;
  background: linear-gradient(90deg, rgba(39, 232, 255, 0.06), rgba(39, 232, 255, 0.14), rgba(39, 232, 255, 0.06));
  border: 1px solid var(--accent-dim);
  color: var(--text);
  font-family: var(--font);
  font-size: 15px;
  letter-spacing: 0.42em;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.18s ease;
  clip-path: polygon(12px 0, 100% 0, calc(100% - 12px) 100%, 0 100%);
}
.ns-btn:hover {
  border-color: var(--accent);
  background: linear-gradient(90deg, rgba(39, 232, 255, 0.16), rgba(39, 232, 255, 0.3), rgba(39, 232, 255, 0.16));
  box-shadow: 0 0 24px rgba(39, 232, 255, 0.35);
  color: #fff;
}
.ns-btn.visor-hover {
  border-color: var(--accent);
  background: linear-gradient(90deg, rgba(39, 232, 255, 0.16), rgba(39, 232, 255, 0.3), rgba(39, 232, 255, 0.16));
  box-shadow: 0 0 24px rgba(39, 232, 255, 0.35);
  color: #fff;
}
.ns-btn.danger { border-color: rgba(255, 59, 48, 0.4); }
.ns-btn.danger:hover, .ns-btn.danger.visor-hover {
  border-color: var(--danger);
  box-shadow: 0 0 24px rgba(255, 59, 48, 0.35);
}

.ns-panel {
  pointer-events: auto; /* panels must receive wheel events for scrolling */
  position: relative;
  z-index: 10; /* overlay screens sit ABOVE the HUD corner panels */
  background: var(--panel);
  border: 1px solid var(--accent-dim);
  backdrop-filter: blur(6px);
  padding: 26px 34px;
}
.ns-panel::-webkit-scrollbar { width: 9px; }
.ns-panel::-webkit-scrollbar-track { background: rgba(255, 255, 255, 0.04); }
.ns-panel::-webkit-scrollbar-thumb { background: var(--accent-dim); border-radius: 0; }
.ns-panel::-webkit-scrollbar-thumb:hover { background: var(--accent); }
`, "",{"version":3,"sources":["webpack://./src/ui/styles/foundation.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,sCAAsC;EACtC,eAAe;EACf,iBAAiB;EACjB,8BAA8B;EAC9B,eAAe;EACf,uDAAuD;AACzD;;AAEA,IAAI,SAAS,EAAE,UAAU,EAAE,sBAAsB,EAAE;;AAEnD,aAAa,WAAW,EAAE,YAAY,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AAE5E,OAAO,eAAe,EAAE,QAAQ,EAAE;;AAElC,eAAe,kBAAkB,EAAE,QAAQ,EAAE,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE;;AAExF;EACE,kBAAkB,EAAE,QAAQ;EAC5B,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,sCAAsC;AACtC;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gHAAgH;EAChH,mCAAmC;EACnC,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,0BAA0B;EAC1B,kEAAkE;AACpE;AACA;EACE,2BAA2B;EAC3B,+GAA+G;EAC/G,6CAA6C;EAC7C,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,+GAA+G;EAC/G,6CAA6C;EAC7C,WAAW;AACb;AACA,iBAAiB,oCAAoC,EAAE;AACvD;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB,EAAE,mDAAmD;EACzE,kBAAkB;EAClB,WAAW,EAAE,oDAAoD;EACjE,wBAAwB;EACxB,mCAAmC;EACnC,0BAA0B;EAC1B,kBAAkB;AACpB;AACA,+BAA+B,UAAU,EAAE;AAC3C,qCAAqC,qCAAqC,EAAE;AAC5E,qCAAqC,6BAA6B,EAAE,gBAAgB,EAAE;AACtF,2CAA2C,yBAAyB,EAAE","sourcesContent":["/* ---------- base ---------- */\n:root {\n  --accent: #27e8ff;\n  --accent-dim: rgba(39, 232, 255, 0.35);\n  --warn: #ffb347;\n  --danger: #ff3b30;\n  --panel: rgba(6, 14, 22, 0.72);\n  --text: #d7f4ff;\n  --font: 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;\n}\n\n* { margin: 0; padding: 0; box-sizing: border-box; }\n\nhtml, body { width: 100%; height: 100%; overflow: hidden; background: #000; }\n\n#app { position: fixed; inset: 0; }\n\n#game-canvas { position: absolute; inset: 0; width: 100%; height: 100%; display: block; }\n\n#ui-root {\n  position: absolute; inset: 0;\n  font-family: var(--font);\n  color: var(--text);\n  pointer-events: none;\n  user-select: none;\n}\n\n/* ---------- shared bits ---------- */\n.ns-btn {\n  pointer-events: auto;\n  display: block;\n  min-width: 260px;\n  margin: 10px auto;\n  padding: 13px 34px;\n  background: linear-gradient(90deg, rgba(39, 232, 255, 0.06), rgba(39, 232, 255, 0.14), rgba(39, 232, 255, 0.06));\n  border: 1px solid var(--accent-dim);\n  color: var(--text);\n  font-family: var(--font);\n  font-size: 15px;\n  letter-spacing: 0.42em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: all 0.18s ease;\n  clip-path: polygon(12px 0, 100% 0, calc(100% - 12px) 100%, 0 100%);\n}\n.ns-btn:hover {\n  border-color: var(--accent);\n  background: linear-gradient(90deg, rgba(39, 232, 255, 0.16), rgba(39, 232, 255, 0.3), rgba(39, 232, 255, 0.16));\n  box-shadow: 0 0 24px rgba(39, 232, 255, 0.35);\n  color: #fff;\n}\n.ns-btn.visor-hover {\n  border-color: var(--accent);\n  background: linear-gradient(90deg, rgba(39, 232, 255, 0.16), rgba(39, 232, 255, 0.3), rgba(39, 232, 255, 0.16));\n  box-shadow: 0 0 24px rgba(39, 232, 255, 0.35);\n  color: #fff;\n}\n.ns-btn.danger { border-color: rgba(255, 59, 48, 0.4); }\n.ns-btn.danger:hover, .ns-btn.danger.visor-hover {\n  border-color: var(--danger);\n  box-shadow: 0 0 24px rgba(255, 59, 48, 0.35);\n}\n\n.ns-panel {\n  pointer-events: auto; /* panels must receive wheel events for scrolling */\n  position: relative;\n  z-index: 10; /* overlay screens sit ABOVE the HUD corner panels */\n  background: var(--panel);\n  border: 1px solid var(--accent-dim);\n  backdrop-filter: blur(6px);\n  padding: 26px 34px;\n}\n.ns-panel::-webkit-scrollbar { width: 9px; }\n.ns-panel::-webkit-scrollbar-track { background: rgba(255, 255, 255, 0.04); }\n.ns-panel::-webkit-scrollbar-thumb { background: var(--accent-dim); border-radius: 0; }\n.ns-panel::-webkit-scrollbar-thumb:hover { background: var(--accent); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
